export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8892.77ddfc19.jpg";